function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "37.565",
  height: "37.565",
  viewBox: "0 0 47.565 47.565"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Group_243",
  "data-name": "Group 243",
  transform: "translate(-960 -452)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_25",
  "data-name": "Group 25",
  transform: "translate(972 464)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_17",
  "data-name": "Path 17",
  d: "M0 0h24.246v24.246H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_18",
  "data-name": "Path 18",
  d: "M4 22.215a8.082 8.082 0 1116.164 0h-2.02a6.061 6.061 0 10-12.123 0zm8.082-9.092a6.061 6.061 0 116.061-6.061 6.06 6.06 0 01-6.061 6.061zm0-2.02a4.041 4.041 0 10-4.041-4.042 4.04 4.04 0 004.041 4.039z",
  transform: "translate(.041 .01)",
  fill: "#f5f5f5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path_19",
  "data-name": "Path 19",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.783 0A23.783 23.783 0 110 23.783 23.783 23.783 0 0123.783 0z",
  transform: "translate(960 452)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.783 2A21.712 21.712 0 008.38 8.38 21.712 21.712 0 002 23.783a21.713 21.713 0 006.38 15.403 21.713 21.713 0 0015.403 6.38 21.713 21.713 0 0015.403-6.38 21.713 21.713 0 006.38-15.403 21.713 21.713 0 00-6.38-15.403A21.713 21.713 0 0023.782 2m0-2c13.134 0 23.782 10.648 23.782 23.783 0 13.134-10.648 23.782-23.782 23.782C10.648 47.565 0 36.917 0 23.783 0 10.648 10.648 0 23.783 0z",
  fill: "#e2e2e2",
  transform: "translate(960 452)"
})))));